const TOP_DEFAULT_CONFIG = {
  pullText: '下拉刷新',
  triggerText: '释放更新',
  loadingText: '加载中...',
  doneText: '加载完成',
  failText: '加载失败',
  loadedStayTime: 1000,
  stayDistance: 70,
  triggerDistance: 70
};

const BOTTOM_DEFAULT_CONFIG = {
  pullText: '上拉加载',
  triggerText: '释放更新',
  loadingText: '加载中...',
  doneText: '加载完成',
  failText: '加载失败',
  loadedStayTime: 400,
  stayDistance: 50,
  triggerDistance: 70
};

export { TOP_DEFAULT_CONFIG, BOTTOM_DEFAULT_CONFIG };



// WEBPACK FOOTER //
// ./src/components/pull/src/config.js